module.exports = __webpack_public_path__ + "static/media/Nathan King.95037b62.png";